module.exports = __webpack_public_path__ + "img/logomedan.4dce1f1b.png";